import CLIDownload from "../../../../contents/docs/error-tracking/_snippets/cli/download.mdx";
import CLIAuthenticate from "../../../../contents/docs/error-tracking/_snippets/cli/authenticate.mdx";
import StepVerifySymbolSetsUpload from "../../../../contents/docs/error-tracking/_snippets/StepVerifySymbolSetsUpload";
import * as React from 'react';
export default {
  CLIDownload,
  CLIAuthenticate,
  StepVerifySymbolSetsUpload,
  React
};